/*
  Codezoeker op een merkalternatiefpagina.

  Filtert uitsluitend wat al in de HTML staat. Alle codes worden server-side
  gerenderd -- dat is de reden dat deze pagina bestaat: iemand zoekt op een
  artikelcode en moet die in de zoekresultaten van Google terugvinden. Zou
  de lijst pas na het laden verschijnen, dan staat er voor een crawler niets.
  Er gaat dus geen enkel verzoek naar de server bij het typen.

  Zonder JavaScript blijft de volledige lijst gewoon staan; alleen het
  zoekveld doet dan niets. Vandaar dat het veld pas zichtbaar wordt zodra
  dit script draait -- anders bied je een veld aan dat niets doet.

  Er wordt op twee dingen gefilterd: de code zelf en de serienaam. Iemand
  die "impressive" typt krijgt dus ook de groep te zien, niet alleen wie
  een exacte code intikt.
*/
(function () {
  var wortel = document.querySelector('[data-merkalt-codes]');
  if (!wortel) return;

  var veld = wortel.querySelector('[data-merkalt-zoek]');
  var groepen = wortel.querySelectorAll('[data-merkalt-groep]');
  var melding = wortel.querySelector('[data-merkalt-geen]');
  if (!veld || !groepen.length) return;

  /* Het veld staat verborgen in de HTML en wordt hier pas getoond: een
     zoekveld dat niets doet is erger dan geen zoekveld. */
  var wikkel = wortel.querySelector('[data-merkalt-zoekwikkel]');
  if (wikkel) wikkel.hidden = false;

  /* De zoektekst per groep een keer klaarzetten, in plaats van bij elke
     toetsaanslag opnieuw uit de DOM lezen. Met ruim 260 codes scheelt dat
     merkbaar bij snel typen. */
  var index = [];
  for (var i = 0; i < groepen.length; i++) {
    var g = groepen[i];
    index.push({
      el: g,
      tekst: (g.textContent || '').toLowerCase().replace(/\s+/g, ' '),
    });
  }

  function filter() {
    var term = veld.value.trim().toLowerCase();
    var zichtbaar = 0;

    for (var i = 0; i < index.length; i++) {
      var treffer = term === '' || index[i].tekst.indexOf(term) !== -1;
      index[i].el.hidden = !treffer;
      if (treffer) zichtbaar++;
    }

    if (melding) melding.hidden = zichtbaar !== 0;
  }

  veld.addEventListener('input', filter);

  /* Enter mag het formulier niet versturen: er is geen serverkant om naartoe
     te sturen, en een herlaadbeurt zou de ingetypte term wissen. */
  veld.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') e.preventDefault();
  });

  filter();
})();
